import { Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react';
import type {
  SortDirection,
  SortField,
} from 'app/Private/Clients/Detail/BalanceTab/BalanceTable/types/table-row-types';

type SortableHeaderProps = {
  label: string;
  field: 'issueDate' | 'dueDate';
  sortField?: SortField;
  sortDirection?: SortDirection;
  onSort?: (field: 'issueDate' | 'dueDate') => void;
};

export const SortableHeader = ({
  label,
  field,
  sortField,
  sortDirection,
  onSort,
}: SortableHeaderProps) => {
  const isActive = sortField === field;
  const SortIcon = isActive
    ? sortDirection === 'asc'
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  return (
    <UnstyledButton
      onClick={() => onSort?.(field)}
      style={{ display: 'flex', alignItems: 'center', gap: 4 }}
    >
      <Text size="sm" fw={isActive ? 600 : 400}>
        {label}
      </Text>
      <SortIcon size={14} />
    </UnstyledButton>
  );
};
